import { render, staticRenderFns } from "./tags-popup.vue?vue&type=template&id=b5fb5826&scoped=true&"
import script from "./tags-popup.vue?vue&type=script&lang=js&"
export * from "./tags-popup.vue?vue&type=script&lang=js&"
import style0 from "./tags-popup.vue?vue&type=style&index=0&id=b5fb5826&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb5826",
  null
  
)

export default component.exports